import React, { useState, useEffect } from "react";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import pic2 from "../assets/homepage10.jpg";
import pic1 from "../assets/eboard_retreat.jpg";
import pic3 from "../assets/cohort_retreat.jpg";
import { Link } from "react-router-dom";
import "./HomeSlider.css";

export const CarouselItem = ({ width, height, image }) => {
  return (
    <img
      className="carousel-item"
      src={image}
      alt={"error"}
      style={{ height: height, opacity: "83%" }}
    ></img>
  );
};

const HomeSlider = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const updateIndex = (newIndex) => {
    if (newIndex < 0) {
      newIndex = 2;
    } else if (newIndex >= 3) {
      newIndex = 0;
    }
    setActiveIndex(newIndex);
  };
  useEffect(() => {
    const interval = setInterval(() => {
      updateIndex(activeIndex + 1);
    }, 5000);

    return () => {
      if (interval) {
        clearInterval(interval);
      }
    };
  });
  return (
    <div>
      <div className="main-div">
        <button
          onClick={() => {
            updateIndex(activeIndex - 1);
          }}
          className="image-button-1"
        >
          <IoIosArrowBack className="arrow"></IoIosArrowBack>
        </button>
        <div className="slider-content">
          <div className="slider-title-div-1">
            <p className="slider-title-text">Being first,</p>
          </div>
          <div className="slider-title-div-2">
            <p className="slider-title-text">together.</p>
          </div>
          <Link to="about">
            <button className="slider-button">Learn more!</button>
          </Link>
          
          { /*<a href="https://docs.google.com/forms/d/e/1FAIpQLSdVPHBZohKH_HsuerGNsAKgdsH9nOtk1HLSLZnTePfsOl2iNg/viewform"
            target="_blank"
            rel="noopener noreferrer">
            <button className="slider-button">Apply here!</button>
          </a> */ }
        </div>
        <button
          onClick={() => {
            updateIndex(activeIndex + 1);
          }}
          className="image-button-2"
        >
          <IoIosArrowForward className="arrow"></IoIosArrowForward>
        </button>
      </div>
      <div className="carousel">
        <div
          className="inner"
          style={{ transform: `translateX(-${activeIndex * 100}%)` }}
        >
          <CarouselItem height={650} image={pic1}></CarouselItem>
          <CarouselItem height={650} image={pic2}></CarouselItem>
          <CarouselItem height={650} image={pic3}></CarouselItem>
        </div>
      </div>
    </div>
  );
};

export default HomeSlider;